import React, { useEffect, useState } from "react";
import "./Dice.css";
import soundManager from "audio/OrtivisSounds";

const Dice = ({ onRoll }) => {
	const [side, setSide] = useState(1);
	const [rolling, setRolling] = useState(false);
	const [isClickable, setIsClickable] = useState(true);

	const rollDice = () => {
		setIsClickable(false);
		if (rolling) return;
		setRolling(true);
		soundManager.playLoopSound("dice");

		const result = Math.floor(Math.random() * 6) + 1;

		setTimeout(() => {
			setSide(result);
			setRolling(false);
			soundManager.stopLoopSound("dice");
			setTimeout(() => {
				onRoll(result);
			}, 3000);
		}, 1500);
	};

	useEffect(() => {
		setIsClickable(true);
	}, []);

	return (
		<div className="">
			<div
				id="dice"
				data-side={side}
				className={rolling ? "reRoll" : ""}
				onClick={isClickable ? rollDice : null}
			>
				{[1, 2, 3, 4, 5, 6].map((num) => (
					<div key={num} className={`sides side-${num}`}>
						{[...Array(num)].map((_, j) => (
							<span key={j} className={`dot dot-${j + 1}`}></span>
						))}
					</div>
				))}
			</div>
		</div>
	);
};

export default Dice;
